enum Paths {
    paymentMethod = '/payment-methods',
}

export default Paths;


// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/paths.ts